<template>
  <div>
    <v-row dense>
      <v-col cols="10">
        <h2 class="b-indicator__collapse-title">1. Значение показателя</h2>
        <h3 class="b-indicator__collapse-subtitle">Исходные данные:</h3>
        <p>
          <span class="font-weight-bold mb-1">Форма 5.20. (фрагмент)</span><br>
          Сведения об образовательных программах, реализуемых организацией, сведения об образовательных программах,
          реализуемых с использованием сетевой формы, в которых организация выступает в роли базовой организации
          <br>
          по данным формы ВПО-1, человек
        </p>
      </v-col>
    </v-row>
    <wrapper-preview-category style="background: unset; box-shadow: unset">
      <grid-table
          :headers="headers.massive"
          :headers-for-rows="headersForRows"
          :num-cols="headers.countCells"
          :gap="'0'"
          :data-rows="table"
          type-table="grid"
      >
        <template #qibcg20="{row}" style="justify-content: unset; border-right: 1px solid #b7ced9">
          <div style="display:flex; flex-direction: column" v-if="row.qibcg20 === '1'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧПi2020</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcg20, 0, 'integer') }}</div>
        </template>
        <template #qibcg21="{row}">
          <div style="display:flex; flex-direction: column" v-if="row.qibcg21 === '2'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧПi2021</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcg21, 0, 'integer') }}</div>
        </template>
        <template #qibcg22="{row}">
          <div style="display:flex; flex-direction: column" v-if="row.qibcg22 === '3'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧПi2022</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcg22, 0, 'integer') }}</div>
        </template>
        <template #qibcn20="{row}">
          <div style="display:flex; flex-direction: column" v-if="row.qibcn20 === '4'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧПСi2020</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcn20, 0, 'integer') }}</div>
        </template>
        <template #qibcn21="{row}">
          <div style="display:flex; flex-direction: column" v-if="row.qibcn21 === '5'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧПСi2021</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcn21, 0, 'integer') }}</div>
        </template>
        <template #qibcn22="{row}">
          <div style="display:flex; flex-direction: column" v-if="row.qibcn22 === '6'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧПСi2022</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcn22, 0, 'integer') }}</div>
        </template>
      </grid-table>
    </wrapper-preview-category>
    <h3 class="b-indicator__collapse-subtitle mt-5">Расчет значения показателя:</h3>
    <!--    <div v-for="(row, i) in [1, 2, 3]" :key="i">-->
    <div class="d-flex flex-row align-center">
      <formulsFraction :need-bottom-line="true">
        <template>
          <div class="d-flex flex-row align-end">
            {{ item.title }}
            <div class="little-text ">0</div>
          </div>
        </template>
        <template #bottom>значение<br> показателя</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> = (</span>
        </template>
      </formulsFraction>
      <!--         /////////////////////////////////////////////                   -->
      <formulsFractionSimple>
        <template>
          ЧПСi2020
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            ЧПi2020
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          ЧПСi2021
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            ЧПi2021
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          ЧПСi2022
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            ЧПi2022
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">) × 100 </span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">÷ <span class="ml-1">k</span></span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <!--     ///////////////////////////////////////////////    -->
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> (</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm1, 0, 'integer') }}
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm2, 0, 'integer') }}
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm3, 0, 'integer') }}
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm4, 0, 'integer') }}
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm5, 0, 'integer') }}
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm6, 0, 'integer') }}
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">) × 100 </span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">÷ <span class="ml-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.qipngq3, 0, 'integer') }}
          </span>
          </span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">{{ rowOfValues.data[valueForBsm7] }}</span>
        </template>
      </formulsFraction>
      <!--     ///////////////////////////////////////////////    -->
    </div>
    <!--    </div>-->
    <p style="max-width: unset">ЧПСi - {{ textForBSM1 }};</p>
    <p>ЧПi - {{ textForBSM2 }}</p>
    <p>k - количество лет, за которые имеются отчетные данные.</p>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import config from "@/components/cards/indicatiors/cardsTables/config/b25";
import formulsFraction from "@/components/cards/indicatiors/formulsFraction";
import formulsFractionSimple from "@/components/cards/indicatiors/formulsFractionSimple"

export default {
  name: "b25",
  components: {GridTable, WrapperPreviewCategory, formulsFraction, formulsFractionSimple},
  props: {
    item: {
      type: Object
    },
    rowOfValues: {
      type: Object,
      default: () => {
      }
    },
  },
  data() {
    return {
      headers: config,
      table: []
    }
  },
  computed: {
    headersForRows() {
      return this.headers.massive.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    textForBSM1() {
      if (this.item.idUsl === 1) {
        return `число программ бакалавриата, реализуемых с использованием сетевой формы в i-ой образовательной организации;`
      } else if (this.item.idUsl === 2) {
        return `число программ специалитета, реализуемых с использованием сетевой формы в i-ой образовательной организации;`
      } else if (this.item.idUsl === 3) {
        return `число программ магистратуры, реализуемых с использованием сетевой формы в i-ой образовательной организации;`
      } else {
        return ''
      }
    },
    textForBSM2() {
      if (this.item.idUsl === 1) {
        return `число реализуемых образовательных программ бакалавриата в i-ой образовательной организации;`
      } else if (this.item.idUsl === 2) {
        return `число реализуемых образовательных программ специалитета в i-ой образовательной организации;`
      } else if (this.item.idUsl === 3) {
        return `число реализуемых образовательных программ магистратуры в i-ой образовательной организации;`
      } else {
        return ''
      }
    },
    valueForBsm1() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.qibcn20
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.qispn20
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.qimgn20
      } else {
        return ''
      }
    },
    valueForBsm2() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.qibcg20
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.qispg20
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.qimgg20
      } else {
        return ''
      }
    },
    valueForBsm3() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.qibcn21
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.qispn21
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.qimgn21
      } else {
        return ''
      }
    },
    valueForBsm4() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.qibcg21
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.qispg21
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.qimgg21
      } else {
        return ''
      }
    },
    valueForBsm5() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.qibcn22
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.qispn22
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.qimgn22
      } else {
        return ''
      }
    },
    valueForBsm6() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.qibcg22
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.qispg22
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.qimgg22
      } else {
        return ''
      }
    },
    valueForBsm7() {
      return String(this.item.dataFieldName) + 'b022'
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.table = [
        {
          bsm: '',
          qibcg20: '1',
          qibcg21: '2',
          qibcg22: '3',
          qibcn20: '4',
          qibcn21: '5',
          qibcn22: '6',
        },
      ];

      if (this.item.idUsl === 1) {
        this.table.unshift({
          bsm: 'Бакалавриат',
          qibcg20: this.rowOfValues.data.qibcg20,
          qibcg21: this.rowOfValues.data.qibcg21,
          qibcg22: this.rowOfValues.data.qibcg22,
          qibcn20: this.rowOfValues.data.qibcn20,
          qibcn21: this.rowOfValues.data.qibcn21,
          qibcn22: this.rowOfValues.data.qibcn22,
        })
      } else if (this.item.idUsl === 2) {
        this.table.unshift({
          bsm: 'Специалитет',
          qibcg20: this.rowOfValues.data.qispg20,
          qibcg21: this.rowOfValues.data.qispg21,
          qibcg22: this.rowOfValues.data.qispg22,
          qibcn20: this.rowOfValues.data.qispn20,
          qibcn21: this.rowOfValues.data.qispn21,
          qibcn22: this.rowOfValues.data.qispn22,
        },)
      } else if (this.item.idUsl === 3) {
        this.table.unshift({
          bsm: 'Магистратура',
          qibcg20: this.rowOfValues.data.qimgg20,
          qibcg21: this.rowOfValues.data.qimgg21,
          qibcg22: this.rowOfValues.data.qimgg22,
          qibcn20: this.rowOfValues.data.qimgn20,
          qibcn21: this.rowOfValues.data.qimgn21,
          qibcn22: this.rowOfValues.data.qimgn22,
        },)
      }
    }
  }
}
</script>

<style lang="sass" scoped>

</style>